import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { IReportData } from '@/libs/LibsReporHelper';

/**
 * 评估申请录入模块
 *
 * @export
 * @interface IEvaluationApplication
 */
export interface IEvaluationApplication {
	applicationData: any;
}

/** 评估申请录入store */
@Module({
	dynamic: true,
	store,
	name: 'evaluationApplication'
})
class ModuleEvaluationApplication extends VuexModule {
	/** 评估申请录入参数 */
	public applicationData: any = {};

	/** 派发事件 mutation */
	@Mutation
	public PREVIEW_PARAM_EVENT(payload: any): any {
		this.applicationData = payload;
	}

	/** 派发事件 action */
	@Action
	public previewParamEvent(payload: any): any {
		this.PREVIEW_PARAM_EVENT(payload);
	}

	/** 评估申请详情参数 */
	public applicationDetailData: any = {};

	/** 派发事件 mutation */
	@Mutation
	public SET_PARAM_EVENT(payload: any): any {
		this.applicationDetailData = payload;
	}

	/** 派发事件 action */
	@Action
	public setParamEvent(payload: any): any {
		this.SET_PARAM_EVENT(payload);
	}

	/** 我的申请单查询 */
	public applicationMyEntryData: any = {};

	/** 派发事件 mutation */
	@Mutation
	public SET_MY_ENTYRY_EVENT(payload: any): any {
		this.applicationMyEntryData = payload;
	}

	/** 派发事件 action */
	@Action
	public setMyEntryEvent(payload: any): any {
		this.SET_MY_ENTYRY_EVENT(payload);
	}

	/** 评估申请浏览 */
	public applicationBrowser: any = {};

	/** 派发事件 mutation */
	@Mutation
	public GET_CSIG_DETAILS(payload: any): any {
		this.applicationBrowser = payload;
	}

	/** 派发事件 action */
	@Action
	public getCsigDetails(payload: any): any {
		this.GET_CSIG_DETAILS(payload);
	}

	/** ds查询部门平台值 */
	public platformList: Array<string> = [];

	/** 派发事件 mutation */
	@Mutation
	public GET_PLATFORM_LIST(payload: any): any {
		this.platformList = payload;
	}

	/** 派发事件 action */
	@Action
	public getPlatFormList(payload: any): any {
		this.GET_PLATFORM_LIST(payload);
	}
}

/** 评估指标store */
export const evaluationApplicationModule: ModuleEvaluationApplication = getModule(ModuleEvaluationApplication);
